if (!customElements.get('custom-italicized-text')) {
    class CustomItalicizedText extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init() {
            // Get the value from the data-value attribute
            const rawValue = this.getAttribute('data-value');
            
            if (rawValue && typeof rawValue === 'string') {
                const italicRegExp = /(_){1}(.+?)(_){1}/g;
                this.innerHTML = rawValue.replace(italicRegExp, (_, __, content) => `<i>${content}</i>`)
            } else {
                this.innerHTML = ''; // Handle cases where the value is missing or invalid
            }
        }
    }

    customElements.define(
        'custom-italicized-text',
        CustomItalicizedText,
    )
}